import {FeatureFlagsEnum} from '../../../libs/shared/core/src/store/featureFlags/featureFlagsTypes';
import {AppRoutesPrefixesEnum} from '../../../libs/shared/ui/src/routing/appRoutesPrefixes';

/*
 * Props.
 */

export interface LegacySettingsRewriteRoute {
  legacyPath: string;
  newPath: string;
  featureFlag?: FeatureFlagsEnum;
}

interface LegacyRouteToNewRoute {
  legacyRoute: string;
  newRoute: string;
}

export type SettingsLegacyRewriteRouteFinder = (path: string | undefined) => string | undefined;

/*
 * App Store Routes.
 */

const appsRoutes: ReadonlyArray<LegacyRouteToNewRoute> = [
  {
    legacyRoute: 'integrations',
    newRoute: 'apps',
  },
  {
    legacyRoute: 'integrations/native',
    newRoute: 'apps',
  },
  {
    legacyRoute: 'integrations/native/edit/:integrationType/details',
    newRoute: 'apps/details/:integrationType/overview',
  },
  {
    legacyRoute: 'integrations/native/edit/:integrationType/settings',
    newRoute: 'apps/details/:integrationType/overview?open_configuration=true',
  },
];

const settingsAppsRoutes: ReadonlyArray<LegacySettingsRewriteRoute> = appsRoutes.map((details) => ({
  legacyPath: `/${AppRoutesPrefixesEnum.SETTINGS}/${details.legacyRoute}`,
  newPath: `/${AppRoutesPrefixesEnum.SETTINGS}/${details.newRoute}`,
}));

/*
 * Developer settings.
 */

const developerSettingsRoutes: ReadonlyArray<LegacyRouteToNewRoute> = [
  // If they land on the base page, redirect them to the imports tab.
  {
    legacyRoute: 'tools',
    newRoute: 'tools/imports',
  },
  {
    legacyRoute: 'tools/plugins',
    newRoute: 'developers',
  },
  {
    legacyRoute: 'tools/api',
    newRoute: 'developers/tokens',
  },
  // Open the token in the new UI
  {
    legacyRoute: 'tools/api/:tokenId',
    newRoute: 'developers/tokens/:tokenId',
  },
  // Redirect the user to the new developers settings. This can not be mapped 1-1 since we are not
  // reusing the plugins id for the new application.
  {
    legacyRoute: 'tools/plugins/edit/:pluginId',
    newRoute: 'developers',
  },
];

const settingsDevelopersRoutes: ReadonlyArray<LegacySettingsRewriteRoute> = developerSettingsRoutes.map(
  (details) => ({
    legacyPath: `/${AppRoutesPrefixesEnum.SETTINGS}/${details.legacyRoute}`,
    newPath: `/${AppRoutesPrefixesEnum.SETTINGS}/${details.newRoute}`,
  }),
);

/*
 * Union of routes.
 */

export const legacySettingsRewriteRoutes: ReadonlyArray<LegacySettingsRewriteRoute> = [
  ...settingsAppsRoutes,
  ...settingsDevelopersRoutes,
];
